/**
 *  https://stackoverflow.com/questions/432493/how-do-you-access-the-matched-groups-in-a-javascript-regular-expression
 *
 **/
export default function* matchAll(str: string, regexp: RegExp): Generator<RegExpExecArray, void, unknown> {
  const flags = regexp.global ? regexp.flags : regexp.flags + "g";
  const re = new RegExp(regexp, flags);
  let match;
  while ((match = re.exec(str))) {
    yield match;
  }
}
